// extracted by mini-css-extract-plugin
module.exports = {"box":"linkBlock_box__3fzEa"};